import { render, staticRenderFns } from "./Classificacao.vue?vue&type=template&id=556d8bc4&scoped=true"
import script from "./Classificacao.vue?vue&type=script&lang=js"
export * from "./Classificacao.vue?vue&type=script&lang=js"
import style0 from "./Classificacao.vue?vue&type=style&index=0&id=556d8bc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "556d8bc4",
  null
  
)

export default component.exports